export const getFileExtension = (filename) => {
    return filename.split('.').pop();
};